'use strict'

angular.module('rmCampaign')
    .controller('CampaignOverviewCtrl', require('./campaign_overview_ctrl'))
    .controller('CampaignFormCtrl', require('./campaign_form_ctrl'))
    .controller('CampaignScheduleCtrl', require('./campaign_schedule_ctrl'))
    .controller('CampaignItemCtrl', require('./campaign_item_ctrl').default)
